import React from 'react';
import { Button } from 'antd';

import { ITeamMember } from '../interfaces';
import styles from './TeamMemberCard.module.scss';

type Props = {
  member: ITeamMember;
  onPreview: (member: ITeamMember) => void;
};

export default function TeamMemberCard(props: Props) {
  const { member, onPreview } = props;

  return (
    <div className={styles.card}>
      <div className={styles.cardImg}>
        <img src={member.avatar} alt={`${member.name} avatar`} />
      </div>

      <div className={styles.cardInfo}>
        <div className={styles.cardInfoFront}>
          <div className={styles.cardName}>{member.name}</div>
          <div className={styles.cardPosition}>{member.position}</div>
        </div>

        <div className={styles.cardInfoBack}>
          <Button className={styles.cardBtn} onClick={() => onPreview(member)}>View more</Button>
          <ul className={styles.cardSocial}>
            <li>
              <a href={member.linkedInLink} target="blank">
                <span className="icon icon-linkedin-circle" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
